import { ref } from 'vue'

const showCreateCompanyModal = ref(false)

export function useCreateCompanyModal() {
  const openModal = () => {
    showCreateCompanyModal.value = true
  }

  const closeModal = () => {
    showCreateCompanyModal.value = false
  }

  return {
    showCreateCompanyModal,
    openModal,
    closeModal,
  }
}
